require('./addBeneficiaryStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
// @ actions
const addBeneficiaryActions = require('actions/addBeneficiary');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const AddBeneficiaryProfile = require('components/transfers/transfersAgenda/addBeneficiary/addBeneficiaryStep1/addBeneficiaryProfile');
const AddBeneficiaryAccounts = require('components/transfers/transfersAgenda/addBeneficiary/addBeneficiaryStep1/addBeneficiaryAccounts');
// @constants
const { BENIFICIARY_TECH_ERROR, BENIFICIARY_COUNTRYMATCH_ERROR, BENIFICIARY_CORRECTIBAN_ERROR } = require('constants/index');
// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');

class AddBeneficiaryStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }
    getErrorMessage(error){
        let errorMsg;
        switch(error){
            case BENIFICIARY_TECH_ERROR:
                errorMsg = formatText('transferSummary-technicalError');
                break;
            case BENIFICIARY_COUNTRYMATCH_ERROR:
                errorMsg = formatText('transferSummary-countryMatchError');
                break;
            case BENIFICIARY_CORRECTIBAN_ERROR:
                errorMsg = formatText('transferSummary-correctIbanError');
                break;    

        }
        return errorMsg;
    }
    render() {
        const { actions, immAddBeneficiary, immBeneficiaries, immBankEntity } = this.props;
        const immFirstStep = immAddBeneficiary.getIn(['steps', 0]);

        let failValidationMsgContent;
        if ( immFirstStep.get('validationRan') && (!immFirstStep.get('valid') || immAddBeneficiary.get('error')) ) {
            // show error message if ui validation failed or validation with api failed
            const error = immAddBeneficiary.get('error');
            const errorMsg = error && this.getErrorMessage(error);
            const errorMessage =  errorMsg || formatText('transferSummary-validationErrorMessage');
            failValidationMsgContent = (
                <OKMessage
                    id="add-beneficiary-validation-fail-error-box"
                    type="informative"
                >
                    {errorMessage}
                </OKMessage>
            );
        }

        return (
            <div className="add-beneficiary-step-one">
                {failValidationMsgContent}
                <header className="add-beneficiary-step-two__header">
                    <FormattedText value="addBeneficiary-step1Title" />
                </header>
                <AddBeneficiaryProfile actions={actions} immBeneficiaries={immBeneficiaries} immAddBeneficiary={immFirstStep}/>
                <AddBeneficiaryAccounts actions={actions} immAddBeneficiary={immFirstStep} immBankEntity={immBankEntity} />
            </div>
        );
    }
}

AddBeneficiaryStep1.propTypes = {
    actions: PropTypes.object,
    immAddBeneficiary: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiaries: PropTypes.object
};

module.exports.constructor = AddBeneficiaryStep1;
module.exports.AddBeneficiaryStep1 = connect(null,
   dispatch => ({ actions: bindActionCreators(addBeneficiaryActions, dispatch)})
)(AddBeneficiaryStep1);